export default "__VITE_ASSET__Dv9wbwq___"